import { Injectable } from '@angular/core';
import { DragModifiers, GridIndexPath, ItemSelectionStore } from '@shared/ui';

import { RoiFilteringEffects } from '../../effects';

export interface DragSelectionFrameInput {
  indexPaths: GridIndexPath[];
  cellsPerRow: number;
  modifiers: DragModifiers;
}

@Injectable()
export class DragSelectionStateController {
  private snapshot: ReadonlySet<string> = new Set();

  constructor(
    private readonly itemSelectionStore: ItemSelectionStore,
    private readonly roiFilteringEffects: RoiFilteringEffects
  ) {}

  public start(): void {
    this.snapshot = new Set(this.itemSelectionStore.getSelectedItems());
  }

  public update(input: DragSelectionFrameInput): void {
    this.roiFilteringEffects.applyDragSelection({
      indexPaths: input.indexPaths,
      cellsPerRow: input.cellsPerRow,
      snapshot: this.snapshot,
      modifiers: input.modifiers,
    });
  }

  public commit(input: DragSelectionFrameInput): void {
    this.update(input);
    this.snapshot = new Set();
  }

  public cancel(): void {
    this.itemSelectionStore.setSelectedItems(new Set(this.snapshot));
    this.snapshot = new Set();
  }
}
